import { X } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { format } from "date-fns";

interface CommentViewPopoverProps {
  comment: {
    author: string;
    initials: string;
    content: string;
    timestamp: string;
    rawTimestamp?: string;
  };
  position: { top: number; left: number };
  onClose: () => void;
}

const CommentViewPopover = ({ comment, position, onClose }: CommentViewPopoverProps) => {
  return (
    <div
      className="fixed z-50 w-72 bg-card rounded-lg border border-foreground/10 shadow-xl animate-in fade-in-0 zoom-in-95"
      style={{
        top: position.top,
        left: position.left,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-3 py-2 border-b border-foreground/10">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-6 h-6 rounded-full bg-foreground text-background flex items-center justify-center flex-shrink-0">
            <span className="text-[10px] font-medium">{comment.initials}</span>
          </div>
          <span className="text-xs font-medium text-foreground truncate">{comment.author}</span>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="text-[10px] text-muted-foreground flex-shrink-0">
                  {comment.timestamp}
                </span>
              </TooltipTrigger>
              <TooltipContent side="top" className="text-xs">
                {comment.rawTimestamp 
                  ? format(new Date(comment.rawTimestamp), "MMM d, yyyy 'at' h:mm a")
                  : comment.timestamp}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0 ml-2"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>

      {/* Content */}
      <div className="p-3">
        <p className="text-xs text-foreground whitespace-pre-wrap">{comment.content}</p>
      </div>
    </div>
  );
};

export default CommentViewPopover;
